import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getEstadosCandidatos = query =>
	fetch.get(
		`/estados-candidatos${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getEstadoCandidato = ({ id, query }) =>
	fetch.get(
		`/estados-candidatos/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addEstadoCandidato = data =>
	fetch.post('/estados-candidatos', data);
export const updateEstadoCandidato = ({ id, ...data }) =>
	fetch.put(`/estados-candidatos/${id}`, data);
export const deleteEstadoCandidato = id =>
	fetch.delete(`/estados-candidatos/${id}`);

// RTK Query
export const estadosCandidatosApi = createApi({
	reducerPath: 'estadosCandidatosApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getEstadosCandidatos: build.query({
			query: query => {
				return {
					url: `/estados-candidatos${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'EstadosCandidatos',
								id,
							})),
							{ type: 'EstadosCandidatos', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'EstadosCandidatos', id: 'LIST' }],
		}),
		getEstadoCandidato: build.query({
			query: ({ id, query }) => {
				return {
					url: `/estados-candidatos/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [
				{ type: 'EstadosCandidatos', id },
			],
		}),
		addEstadoCandidato: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/estados-candidatos`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Estado Candidato agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar estado candidato');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'EstadosCandidatos', id: 'LIST' }],
		}),
		updateEstadoCandidato: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/estados-candidatos/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Estado Candidato actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar estado candidato');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'EstadosCandidatos', id },
			],
		}),
		deleteEstadoCandidato: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/estados-candidatos/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Estado Candidato eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar estado candidato');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [
				{ type: 'EstadosCandidatos', id },
			],
		}),
	}),
});

export const {
	useGetEstadosCandidatosQuery,
	useGetEstadoCandidatoQuery,
	useAddEstadoCandidatoMutation,
	useUpdateEstadoCandidatoMutation,
	useDeleteEstadoCandidatoMutation,
} = estadosCandidatosApi;
